<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="可用量查询"
      :page="page"
      :show-query="true"
      :queryParamsAppend="params"
      :get-data-func="api.currentStockRpt"
      v-if="trendShow"
      urlHash="business/stock/availablequa"
      @reset="reset"
    >  
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template> 
      <template slot="query">
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <list-dialog ref="listDialog" in-dialog selectable @select="setProduct" />
   
  </div>
</template>
<script>

  
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import listDialog from '@/components/basedata/inventory/archives/listDialog'
export default {
  mixins: [listMixin],
  components: { list, listDialog },
  data() {
    return {
      api: require('@/api/stock/stReport').default,
      trendShow: true,
      tableData: [],
      ProductName: "",
      params: {
        ItemValue: null 
      }
    };
  },
   mounted(){
     ;
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.currentStockRptExport(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    reset(){
      this.$refs.list.queryParams={}
    },
    openProduct(){
      this.$refs.listDialog.open()
    },
    setProduct(data){
      this.ProductName = data.ProductName;
      this.params.ItemValue = data.ProductId
    }
   
  }
};
</script>
